import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class filterDropdown_template extends vnTemplate {

    protected firstOptionLoad = true;

    protected getTemplateHtml(): string {

        return `
                    
                    <select data-bind="
                        options: options,
                        optionsText: 'name',
                        optionsValue: 'id',
                        value: selectedOption,
                        event: { change: onChangeFilterAction }
                    "></select>
            `;
    }

    protected getTemplateName(): string {
        return 'filterDropdown-template';
    }

    protected buildViewModel(): object {

        let huit_neuf_this = this;

        return {
            label: ko.observable("")
            ,options: ko.observableArray([{ id: 0, name: 'all'}])
            ,selectedOption: ko.observable(0)
            ,setOptions: function (data, event) { huit_neuf_this.setOptions(data); }
            ,setLabel: function (data, event) { huit_neuf_this.setLabel(data); }
            ,setSelectedOption: function (data, event) { huit_neuf_this.setSelectedOption(data); }
            ,onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data);},
        };
    }

    public onChangeFilterAction(data) {

        if( !this.firstOptionLoad ) {
            this.caller.filterDropdownOnChange(this.idElement);
        }
        this.firstOptionLoad = false;
    }

    public setSelectedOption(optionId: number) {

        this.getTemplateViewModel().selectedOption(optionId);
    }

    public setOptions(options) {

        this.getTemplateViewModel().options(options);
    }

    public addOptions(options) {

        let a = this.getTemplateViewModel().options().concat(options);

        this.getTemplateViewModel().options(a);
    }

    public setLabel(label : string) {

        this.getTemplateViewModel().label(label);
    }
}



// WEBPACK FOOTER //
// ./common/js/vnKnockoutJsTemplates/filterDropdown_template.ts